//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Mobile from '~/components/detail/mobile'
import Desktop from '~/components/detail/desktop'
import DetailNav from '~/components/detail/detail_nav'
import global from '~/mixins/global'
export default {
  components: {
    DetailNav,
    Mobile,
    Desktop
  },
  mixins: [global],
  async asyncData ({ params, store, redirect }) {
    await global.methods.getNewAndTrends(store, process.env.FAPI_URL, process.env.ASYNC_BASE_URL_API)
    await store.dispatch('coins/getCoins')
    if (params.symbol === 'perfectmoney' || params.symbol === 'payeer') {
      const digitalData = await store.dispatch('axios/get', { url: '/application/pwInfo/TOMAN', config: { baseURL: process.env.BASE_ASYNC_UUID } })
      const weblog = await store.dispatch('axios/get', { url: process.env.FAPI_URL + '/fapi/coins/' + params.symbol })
      const data = {
        digital: true,
        title: params.symbol === 'perfectmoney' ? 'pm' : 'py',
        fa_name: params.symbol === 'perfectmoney' ? 'پرفکت مانی' : 'پاییر',
        en_name: params.symbol === 'perfectmoney' ? 'Perfect Money' : 'Payeer',
        symbol: params.symbol === 'perfectmoney' ? 'PM' : 'PY',
        digitalData: digitalData.data.data
      }
      const coin = {
        data,
        weblog: weblog.data.data
      }
      return {
        coin
      }
    } else {
      if (params.symbol === 'binance-coin' || params.symbol === 'binancecoin') {
        redirect('bnb')
      }
      await store.dispatch('coins/getDollarPrice', process.env.BASE_ASYNC_UUID)
      try {
        const data = await store.dispatch('axios/get', { url: process.env.FAPI_URL + '/fapi/coins/info/' + params.symbol })
        const weblog = await store.dispatch('axios/get', { url: process.env.FAPI_URL + '/fapi/coins/' + params.symbol })
        const addItem = { fa_name: store.getters['coins/getSymbolFaName'](data.data.data.symbol) }
        Object.assign(data.data.data, addItem)
        const coin = {
          data: data.data.data,
          weblog: weblog.data.data
        }
        if (params.symbol === 'tether') {
          const tetherData = await store.dispatch('axios/get', { url: '/history/tetherPrice', config: { baseURL: process.env.ASYNC_BASE_URL_API } })
          coin.tetherData = tetherData.data.data
        }
        return {
          coin
        }
      } catch (e) {
        return { coin: { data: {}, weblog: {} } }
      }
    }
  },
  data () {
    return {
      search: null,
      timer: 0,
      timerInterval: null
    }
  },
  head () {
    return {
      title: this.$t('common.buy') + ' ' + this.coin.data.fa_name + ' ' + '|' + ' ' + this.$t('common.sell') + ' ' + this.coin.data.fa_name + ' ' + '|' + ' ' + this.$t('common.price') + ' ' + this.coin.data.fa_name + ' ' + '|' + ' ' + this.$t('common.chart') + ' ' + this.coin.data.fa_name,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('head.detailDesc1') + ' ' + this.coin.data.fa_name + ' ' + this.$t('head.detailDesc2') + ' ' + this.$root.$options.filters.coinSeparator(+this.coin.data.price) + ' ' + this.$t('head.detailDesc3') +
          ' ' + this.$root.$options.filters.tomanSeparator(+this.$store.getters['coins/buyDollarPrice']) + ' ' + this.$t('head.detailDesc4') + ' ' + this.$root.$options.filters.tomanSeparator(this.coin.data.price * +this.$store.getters['coins/buyDollarPrice']) +
            ' ' + this.$t('head.detailDesc5') + ' ' + this.$root.$options.filters.priceAbbreviated(this.coin.data.marketcap) + ' ' + this.$t('head.detailDesc6')
        }
      ]
    }
  },
  watch: {
    'coin.data.price': {
      handler (val) {
        if (+val > +this.coin.data.high_24h) {
          this.coin.data.high_24h = +val
        } else if (+val < +this.coin.data.low_24h) {
          this.coin.data.low_24h = +val
        }
      }
    }
  },
  async mounted () {
    await this.getInitPrice()
    this.timerInterval = setInterval(() => {
      this.timer += 1
    }, 1000)
    this.ws = new WebSocket('wss://push.coinmarketcap.com/ws?device=web&client_source=coin_detail_page')
    this.ws.onopen = (e) => {
      // eslint-disable-next-line no-return-assign
      this.ws.send(JSON.stringify({ method: 'RSUBSCRIPTION', params: ['main-site@crypto_price_15s@{}@detail', `${this.coin.data.p_id}`] })
      )
    }

    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data)
      if (data.d && this.coin.data.p_id === data.d.id) {
        this.coin.data.price = data.d.p
      }
    }
    this.$axios.post('https://www.arzypto.com/capi/seen/' + this.coin.data.slug)
  },
  beforeDestroy () {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }

    if (this.ws) {
      this.ws.close()
    }
  },
  methods: {
    async getInitPrice () {
      if (this.$route.params.symbol !== 'pm' && this.$route.params.symbol !== 'payeer') {
        await this.$store.dispatch('axios/get', {
          url: '/application/coin/priceList',
          config: {
            baseURL: process.env.BASE_URL,
            params: { symbols: this.coin.data.symbol.toUpperCase() + 'USDT' }
          }
        })
          .then((resp) => {
            if (resp.data.data.length > 0) {
              this.coin.data.price = resp.data.data[0].price
            }
          })
      } else {
        await this.$store.dispatch('axios/get', { url: '/application/pwInfo/TOMAN', config: { baseURL: process.env.BASE_URL_UUID } })
          .then((resp) => {
            if (resp.data.data.length > 0) {
              this.coin.data.price = resp.data.data.pm_buy_price
            }
          })
      }
    }
  }
}
